import {createStore} from 'redux'
import rootReducer, {
    ADD_GROUP,
    ADD_USER,
    DELETE_GROUPS,
    DELETE_USERS,
    SET_COMMENT,
    SET_COMMON_FAXSENDER,
    SET_COMMON_FORWARDING_TARGET,
    SET_COMMON_PASSWORD,
    SET_GROUP,
    SET_GROUP_VALIDITY,
    SET_GROUPS,
    SET_LINE_PROPERTIES,
    SET_USER,
    SET_USER_VALIDITY,
    SET_USERS,
    SHOW_EXPORT_UTP_DIALOG,
    SHOW_IMPORT_SUCCESS_DIALOG,
    SHOW_PARTNER_DIALOG,
    TOGGLE_USER_SETTING,
    VALIDATE_ALL
} from './RootReducer';
import {GroupProps, LineProps, UserProps} from "./SetupState";
import {Selection} from "@fluentui/react";

export const store = createStore(rootReducer);

export namespace ReduxDispatch {

    export const setLines = (lineProperties: LineProps) => {
        store.dispatch({type: SET_LINE_PROPERTIES, payload: lineProperties})
    }
    export const setGroup = (index: number, group: GroupProps) => {
        store.dispatch({type: SET_GROUP, payload: group, index: index});
    }
    export const setGroups = (groups: GroupProps[]) => {
        store.dispatch({type: SET_GROUPS, payload: groups});
    }
    export const setUser = (index: number, user: UserProps) => {
        store.dispatch({type: SET_USER, payload: user, index: index});
    }
    export const setUsers = (users: UserProps[]) => {
        store.dispatch({type: SET_USERS, payload: users});
    }
    export const validateAll = () => {
        store.dispatch({type: VALIDATE_ALL});
    }
    export const deleteGroups = (selection: Selection) => {
        store.dispatch({type: DELETE_GROUPS, selection: selection});
    }
    export const deleteUsers = (selection: Selection) => {
        store.dispatch({type: DELETE_USERS, selection: selection});
    }
    export const addUser = () => {
        store.dispatch({type: ADD_USER})
    }
    export const addGroup = () => {
        store.dispatch({type: ADD_GROUP})
    }
    export const toggleSetting = (selection: Selection, attribute: "mwi" | "softphone" | "terminalserver" | "isAdmin") => () => {
        store.dispatch({type: TOGGLE_USER_SETTING, attribute: attribute, selection: selection})
    }
    export const setGroupValid = (index: number, valid: boolean) => {
        store.dispatch({type: SET_GROUP_VALIDITY, validity: valid, index: index})
    }
    export const setUserValid = (index: number, valid: boolean) => {
        store.dispatch({type: SET_USER_VALIDITY, validity: valid, index: index})
    }
    export const setCommonPassword = (password: string | undefined) => {
        if (password) {
            store.dispatch({type: SET_COMMON_PASSWORD, password: password})
        }
    }
    export const setCommonForwardingTarget = (target: string | undefined) => {
        if (target) {
            store.dispatch({type: SET_COMMON_FORWARDING_TARGET, target: target})
        }
    }
    export const setCommonFaxSender = (sender: string | undefined) => {
        if (sender) {
            store.dispatch({type: SET_COMMON_FAXSENDER, sender: sender})
        }
    }
    export const setComment = (comment: string | undefined) => {
        if (comment) {
            store.dispatch({type: SET_COMMENT, comment: comment})
        }
    }

    export const showPartnerDialog = (show: boolean) => {
        store.dispatch({type: SHOW_PARTNER_DIALOG, show: show})
    }
    export const showImportSuccess = (show: boolean) => {
        store.dispatch({type: SHOW_IMPORT_SUCCESS_DIALOG, show: show})
    }
    export const showExportUtpDialog = (show: boolean) => {
        store.dispatch({type: SHOW_EXPORT_UTP_DIALOG, show: show})
    }
}

export namespace ReduxQuery {
    export const userLicenseCount = () => {
        return store.getState().setup.users.reduce(
            (total, currentVal) => { return total + ((currentVal.isValid && currentVal.license === "standard") ? 1 : 0); }, 0);

    }
    export const lightLicenseCount = () => {
        return store.getState().setup.users.reduce(
            (total, currentVal) => { return total + ((currentVal.isValid && currentVal.license === "light") ? 1 : 0); }, 0);
    }
    export const premiumLicenseCount = () => {
        return store.getState().setup.users.reduce(
            (total, currentVal) => { return total + (currentVal.softphone ? 1 : 0); }, 0);
    }
    export const tsLicenseCount = () => {
        return Math.ceil(store.getState().setup.users.reduce(
            (total, currentVal) => { return total + (currentVal.terminalserver ? 1 : 0); }, 0) / 25);
    }
    export const iQueueLicenseCount = () => {
        return store.getState().setup.groups.reduce(
            (total, currentVal) => { return total + ((currentVal.strategy && currentVal.strategy === "iqueue") ? 1 : 0); }, 0);
    }
}